import { connectSearchBox } from 'instantsearch.js/es/connectors';

const virtualSearchBox = connectSearchBox(() => {});

const initVirtualSearchBox = algoliaSearch => {
	algoliaSearch.addWidgets([virtualSearchBox({})]);
};

export default initVirtualSearchBox;
